import { render, staticRenderFns } from "./imgPlaceholder.vue?vue&type=template&id=0f8d20c0&scoped=true&"
import script from "./imgPlaceholder.vue?vue&type=script&lang=js&"
export * from "./imgPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./imgPlaceholder.vue?vue&type=style&index=0&id=0f8d20c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8d20c0",
  null
  
)

export default component.exports